import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0babdf7b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "container search-dropdown dropdown-menu dropdown-white",
  style: {},
  ref: "rootElement"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-8" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider dropdown-header p-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Kategorie")
], -1))
const _hoisted_5 = { class: "row search-results-categories" }
const _hoisted_6 = { class: "fox-main-cat-search-res search-res-group col-sm-24 p-2 cursor-pointer" }
const _hoisted_7 = ["href"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "loading-overlay text-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-spinner fa-spin fa-5x",
  style: {},
  id: "AjaxSpinner"
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "col-sm-16" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider dropdown-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Produkty")
], -1))
const _hoisted_14 = { class: "container search-results-products" }
const _hoisted_15 = {
  ref: "productsContainer",
  class: "fox-main-prod-search-res search-res-group col-sm-24 cursor-pointer row"
}
const _hoisted_16 = { class: "container row" }
const _hoisted_17 = ["href", "title"]
const _hoisted_18 = { class: "container row sr-entry-container py-1" }
const _hoisted_19 = { class: "col-sm-8" }
const _hoisted_20 = { class: "sr-image img-container" }
const _hoisted_21 = ["src", "result-id", "alt"]
const _hoisted_22 = { class: "col-sm-16" }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = { class: "loading-overlay text-center" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-spinner fa-spin fa-5x",
  style: {},
  id: "AjaxSpinner"
}, null, -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1))
const _hoisted_30 = [
  _hoisted_29
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_scroll = _resolveDirective("scroll")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults.categories.data, (searchResult) => {
              return _withDirectives((_openBlock(), _createElementBlock("div", {
                class: "divider p-2 cursor-pointer",
                key: searchResult.url
              }, [
                _createElementVNode("a", {
                  href: searchResult.url
                }, [
                  _createElementVNode("span", {
                    innerHTML: 
                                        searchResult?.highlight?.['content_name.unaccended_ngram'] ?? searchResult?.name
                                    
                  }, null, 8, _hoisted_8)
                ], 8, _hoisted_7)
              ])), [
                [_directive_scroll, [_ctx.loadMoreCategories, { idle: 100 }]]
              ])
            }), 128))
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_9, _hoisted_11, 512), [
            [_vShow, _ctx.searchLoading]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults.products.data, (searchResult) => {
                return (_openBlock(), _createElementBlock("a", {
                  href: searchResult.url,
                  class: "search-res-entry divider cursor-pointer col-sm-12",
                  key: searchResult.id,
                  title: searchResult?.name
                }, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("img", {
                          src: _ctx.baseImageUrl + searchResult.image_url,
                          "result-id": searchResult.id,
                          alt: searchResult?.name,
                          class: "img-thumbnail",
                          style: {}
                        }, null, 8, _hoisted_21)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("span", {
                        innerHTML: 
                                                searchResult?.highlight?.['content_name.unaccended_ngram'] ??
                                                searchResult?.name
                                            
                      }, null, 8, _hoisted_23),
                      _hoisted_24,
                      _createElementVNode("span", {
                        innerHTML: 
                                                !new RegExp('sr-highlight').test(
                                                    searchResult?.highlight?.['content_name.unaccended_ngram']?.[0]
                                                )
                                                    ? searchResult?.highlight?.['description.unaccended_ngram']
                                                    : ''
                                            
                      }, null, 8, _hoisted_25)
                    ])
                  ])
                ], 8, _hoisted_17))
              }), 128))
            ])
          ])), [
            [_directive_scroll, [_ctx.loadMoreProducts, { idle: 100 }]]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_26, _hoisted_28, 512), [
            [_vShow, _ctx.searchLoading]
          ])
        ])
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "close",
        "aria-label": "Close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.searchModuleStore.setResultsVisibility(false)))
      }, _hoisted_30)
    ])
  ], 512)), [
    [_vShow, _ctx.shouldDisplaySearchDialog]
  ])
}